// removed by extract-text-webpack-plugin
module.exports = {"slogan":"_1iuXzDkiMgMiaKQ4Wg-dAc","sloganCht":"_2qiquTaewNFuFDkpItINIP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/info-slogan/InfoSlogan.css
// module id = 395
// module chunks = 0